"use client";

import Link from "next/link";
import {
  historyItemListLabels,
  type ApiGenerationHistoryItem,
} from "@/lib/api/generations";

/** One generation row in History / Projects→History lists. */
export function HistoryListItem({
  item,
  dateLabel,
}: {
  item: ApiGenerationHistoryItem;
  dateLabel: string;
}) {
  const { title, subtitle, modality } = historyItemListLabels(item);

  return (
    <Link
      href={`/history/${item.slug}`}
      className="flex items-center gap-3 border-b border-[rgba(26,24,22,0.07)] px-[18px] py-[13px] transition-colors last:border-b-0 hover:bg-[rgba(17,17,17,0.02)]"
    >
      <div className="min-w-0 flex-1">
        <div className="flex min-w-0 items-center gap-1.5">
          <div className="truncate text-[13.5px] font-semibold text-ink">
            {title}
          </div>
          {modality ? (
            <span className="inline-flex flex-none items-center rounded-full bg-[rgba(26,24,22,0.05)] px-2 py-0.5 text-[9.5px] font-bold uppercase tracking-[0.6px] text-muted">
              {modality}
            </span>
          ) : null}
        </div>
        {subtitle ? (
          <div className="truncate text-[11.5px] text-muted">{subtitle}</div>
        ) : null}
      </div>
      <div className="whitespace-nowrap text-[11.5px] text-muted">
        {dateLabel}
      </div>
    </Link>
  );
}
